import { render, staticRenderFns } from "./BaseDepositWithdrawHistory.vue?vue&type=template&id=b0040f56"
import script from "./BaseDepositWithdrawHistory.vue?vue&type=script&lang=js"
export * from "./BaseDepositWithdrawHistory.vue?vue&type=script&lang=js"
import style0 from "./BaseDepositWithdrawHistory.vue?vue&type=style&index=0&id=b0040f56&prod&lang=scss"
import style1 from "./BaseDepositWithdrawHistory.vue?vue&type=style&index=1&id=b0040f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports